import script from "./HeaderMenu.vue?vue&type=script&setup=true&lang=ts"
export * from "./HeaderMenu.vue?vue&type=script&setup=true&lang=ts"

import "./HeaderMenu.vue?vue&type=style&index=0&id=40a6d328&lang=css"

const __exports__ = script;

export default __exports__